import React, { FC } from 'react';
import { Select } from 'chakra-react-select';
import { FormControl, FormLabel, Text } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { SkuMultiSelectProps } from './SkuMultiSelect.props';

const SkuMultiSelectView: FC<SkuMultiSelectProps> = ({
  values,
  label,
  labelProps,
  onChange,
  isLoadingSKU,
  skus,
}) => {
  const { setFieldTouched, touched } = useFormikContext<any>();

  const options = skus.map((sku) => ({ label: sku.name, value: sku._id }));
  const selectedValues = values
    ? values.map((skuId) => ({
        label: skus.find((sku) => sku._id === skuId)?.name,
        value: skuId,
      }))
    : [];

  return (
    <FormControl mt={3}>
      <FormLabel htmlFor="skus" textTransform="capitalize" {...labelProps}>
        {label}
      </FormLabel>
      <Select
        isMulti
        isDisabled={isLoadingSKU}
        options={options}
        tagVariant="solid"
        colorScheme="primary"
        closeMenuOnSelect={false}
        isLoading={isLoadingSKU}
        value={selectedValues}
        onBlur={() => setFieldTouched('items.skus', true)}
        chakraStyles={{
          dropdownIndicator: (_props) => ({
            ..._props,
            bg: 'transparent',
          }),
          option: (_props) => ({
            ..._props,
            padding: '10px',
            borderBottom: '1px solid #ccc',
          }),
          menuList: (_props) => ({
            ..._props,
            padding: '0px',
            marginBottom: '20px',
          }),
        }}
        onChange={(newValue) => {
          const newSkus = newValue.map((option: any) => option.value);
          onChange(newSkus);
        }}
      />
      {values?.length === 0 && touched.items && (
        <Text color="red.500" fontSize="sm">
          Please select at least one SKU
        </Text>
      )}
    </FormControl>
  );
};

export default SkuMultiSelectView;
